import { useContext } from 'react'
import { Box, useTheme, Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { StickinessContext } from 'src/context/gamePlayInsights/stickiness'
import { CohortsContext } from 'src/context/gamePlayInsights/cohorts'
import StickinessChartView from './stickinessChart'
import ChartSettingView from './chartSetting'
import { LoadingComponent, ChartTypeToggleGroup } from 'src/components'

const getUseStyles = (theme: Theme) =>
  makeStyles(() => {
    return {
      contentBottom: {
        position: 'relative',
        width: '100%',
      },
      loadingMask: {
        display: 'flex',
        position: 'absolute',
        width: '100%',
        justifyContent: 'center',
        height: '100%',
        alignItems: 'center',
        zIndex: 9,
        background: theme.palette.custom?.maskBackground,
      },
    }
  })
const MiddleChart = (): JSX.Element => {
  // const
  const theme: Theme = useTheme()
  const useStyles = getUseStyles(theme)
  const classes = useStyles()
  const { state } = useContext(StickinessContext)
  const { state: cohortsState, dispatch: cohortsDispatch } =
    useContext(CohortsContext)

  // returns
  return (
    <Box className={classes.contentBottom}>
      {state.loading && (
        <Box className={classes.loadingMask}>
          <LoadingComponent />
        </Box>
      )}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            fontSize: '20px',
            lineHeight: '36px',
            fontWeight: 500,
            padding: '0 4px',
          }}
        >
          <Box marginRight="16px">Stickiness</Box>
          <ChartSettingView />
        </Box>
        <ChartTypeToggleGroup
          value={cohortsState.newChartType}
          onChange={(chartType: string) => {
            cohortsDispatch({ type: 'newChartType', payload: chartType })
          }}
        />
      </Box>
      <Box marginTop="26px">
        <StickinessChartView id="chart" width="100" />
      </Box>
    </Box>
  )
}

export default MiddleChart
